import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import { Tooltip, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

import {
  formatCurrencyRounded,
  PartyTypes,
  AuctionStatuses,
  toDateTimeString,
} from 'vdlib';

const getColumns = (auctionStatus, partyType, selectBid) =>
  [
    {
      title: I.t('AA'),
      key: 'AA',
      dataIndex: 'AA',
      width: 100,
      align: 'center',
    },
    {
      title: I.t('AMOUNT'),
      key: 'Amount',
      dataIndex: 'Amount',
      width: 100,
      align: 'center',
      render: (text, record) => formatCurrencyRounded(record.Amount),
    },
    {
      title: I.t('MERCHANT'),
      key: 'Bidder',
      dataIndex: 'Bidder',
      width: 100,
      align: 'center',
    },
    {
      title: I.t('COMMENTS'),
      key: 'Comments',
      dataIndex: 'Comments',
      width: 100,
    },
    {
      title: I.t('DATE'),
      key: 'BidTime',
      dataIndex: 'BidTime',
      width: 120,
      align: 'center',
      render: (text, record) => <span>{toDateTimeString(record.BidTime)}</span>,
    },
  ].concat(
    auctionStatus === AuctionStatuses.ForSelection &&
      partyType === PartyTypes.Insurance
      ? {
          key: 'BidTime',
          dataIndex: 'BidTime',
          width: 120,
          align: 'center',
          render: (text, record) => (
            <Tooltip title={I.t('SELECT')}>
              <Button
                type="primary"
                icon={<CheckCircleOutlined />}
                onClick={() => selectBid(record.ID)}
              />
            </Tooltip>
          ),
        }
      : []
  );

export { getColumns };
